import React from 'react'
import { MdFavorite, MdFavoriteBorder } from 'react-icons/md'
import { useTheme } from '../../hooks/useTheme'
import styles from './FavoriteScreenButton.module.scss'

interface FavoriteScreenButtonProps {
  isFavorite: boolean
  onPress: () => void
  color?: string
  activeColor?: string
  size?: number
  disabled?: boolean
  testID?: string
}

export const FavoriteScreenButton: React.FC<FavoriteScreenButtonProps> = ({
  isFavorite,
  onPress,
  color,
  activeColor,
  size = 24,
  disabled = false,
  testID,
}) => {
  const { theme } = useTheme()

  const defaultColor = theme.textSecondary
  const defaultActiveColor = theme.primary

  const finalColor = isFavorite ? (activeColor ?? defaultActiveColor) : (color ?? defaultColor)

  return (
    <button
      className={styles.button}
      onClick={onPress}
      disabled={disabled}
      aria-label={isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'}
      data-testid={testID}
    >
      {isFavorite ? (
        <MdFavorite size={size} color={finalColor} />
      ) : (
        <MdFavoriteBorder size={size} color={finalColor} />
      )}
    </button>
  )
}